export var constants = {
  ON_CARD: 'on-card',
  IN_CARD: 'in-card',
  UNDER_CARD: 'under-card',
  OFFER: 'offer',
  SOCIAL_PROOF: 'social-proof',
  STELLAR: 'STELLAR',
  MANTLE: 'MANTLE',
  DODGER_BLUE: 'DODGER_BLUE',
  RETRO: 'RETRO',
  LOGO: 'logo',
  LOGO_GROUP: 'logo-group'
};